import { render } from "./wfm-base-row-actions.vue?vue&type=template&id=126ed73e"
import script from "./wfm-base-row-actions.vue?vue&type=script&lang=js"
export * from "./wfm-base-row-actions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__